import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useLang } from '../hooks/useLang';

const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const { t } = useTranslation();
  const { lang, otherLang, routes, switchLangPath } = useLang();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
      scrolled ? 'bg-white shadow-sm' : 'bg-transparent'}`}
      data-testid="site-header">

      <div className="max-w-[1920px] mx-auto px-8 lg:px-16">
        <div className="flex justify-between items-center h-24">
          {/* Logo */}
          <Link to={routes.home} className="flex flex-col items-start" data-testid="logo-link">
            <div className="text-2xl font-light tracking-wider" style={{ fontFamily: 'monospace' }}>
              smarch
            </div>
            <div className="text-[9px] font-light tracking-widest" style={{ fontFamily: 'sans-serif' }}>
              sylvain mazaba architectes
            </div>
          </Link>

          {/* Navigation */}
          <nav className="flex items-center gap-12">
            <div className="hidden md:flex items-center gap-10">
              <Link to={routes.projects} data-testid="nav-projects" className="text-sm font-light tracking-wide hover:text-[#d94e47] transition-colors duration-300">
                {t('nav.projects')}
              </Link>
              <Link to={routes.agency} data-testid="nav-agency" className="text-sm font-light tracking-wide hover:text-[#d94e47] transition-colors duration-300">
                {t('nav.agency')}
              </Link>
              <Link to={routes.careers} data-testid="nav-careers" className="text-sm font-light tracking-wide hover:text-[#d94e47] transition-colors duration-300">
                {t('nav.careers')}
              </Link>
              <Link to={routes.news} data-testid="nav-news" className="text-sm font-light tracking-wide hover:text-[#d94e47] transition-colors duration-300">
                {t('nav.news')}
              </Link>
            </div>

            {/* Secondary links + language switch */}
            <div className="flex items-center gap-6 border-l border-gray-300 pl-6">
              <Link to={routes.contact} data-testid="nav-contact" className="text-xs font-light tracking-wide hover:text-[#d94e47] transition-colors duration-300">
                {t('nav.contact')}
              </Link>
              <Link
                to={switchLangPath()}
                data-testid="lang-switcher"
                aria-label={`Switch to ${otherLang.toUpperCase()}`}
                className="text-xs font-light tracking-wide hover:text-[#d94e47] transition-colors duration-300"
              >
                <span className={lang === 'fr' ? 'font-medium text-black' : 'text-gray-400'}>FR</span>
                <span className="text-gray-400"> / </span>
                <span className={lang === 'en' ? 'font-medium text-black' : 'text-gray-400'}>EN</span>
              </Link>
            </div>
          </nav>
        </div>
      </div>
    </header>);

};

export default Header;
